<template>
  <div class="questionary_accordion">
    <button class="questionary_save" @click="saveMe(true)">Update</button>

    <div>
      <div class="block_title pb-0">
        Beneficiary Info
      </div>
      <div class="block-layout">
        <div class="wizard-container questionnaireeditor" title="Case Details" :before-change="beforeTabSwitch">
          <!-- tab 1 content -->
          <form data-vv-scope="beneficiaryInfoform" @submit.prevent="" @keydown.enter.prevent="">
            <!-- <vs-col class="w-full p-0">
            <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">
              NOTE: This questionnaire should be filled out completely and accurately. Kindly read the instructions
              carefully.
                
            </vs-alert>
          </vs-col> -->

          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" v-if="false">
                <div class="form-container">
                  <div class="vx-row">
                    <!----
                       immPetitionPriorityDate: false, // list your Priority Date obtained from your previous immigrant petition

          applyI485AdjOrConsuProcess: false, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },

          adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },

          consularProcessing:false,// Consular Processing { type: Boolean, default: false },

          areYouUnderRemoveOfIndOrUscis: false, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },


                      ---->
                      <div class="vx-col md:w-1/2 w-full martb10 ">
                      <div class="main-placeholder right">
                        <!-- immPetitionPriorityDate -->
                        <vs-checkbox name="immPetitionPriorityDate"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'immPetitionPriorityDate'})"
                          v-model="beneficiary.immPetitionPriorityDate" class="w-full" label="">list your Priority Date obtained from your previous immigrant petition
                        </vs-checkbox>

                      </div>

                    </div>

                    <div class="vx-col md:w-1/2 w-full martb10 ">
                      <div class="main-placeholder right">
                        <!-- applyI485AdjOrConsuProcess -->
                        <vs-checkbox name="applyI485AdjOrConsuProcess"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'applyI485AdjOrConsuProcess'})"
                          v-model="beneficiary.applyI485AdjOrConsuProcess" class="w-full" label="">Would you like to apply for adjustment of status (I-485) or consular processing?
                        </vs-checkbox>

                      </div>

                    </div>

                    <div class="vx-col md:w-1/2 w-full martb10 ">
                      <div class="main-placeholder right">
                        <!-- adjustmentOfI485Status -->
                        <vs-checkbox name="adjustmentOfI485Status"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'adjustmentOfI485Status'})"
                          v-model="beneficiary.adjustmentOfI485Status" class="w-full" label="">Adjustment of Status (I-485)
                        </vs-checkbox>

                      </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full martb10 ">
                      <div class="main-placeholder right">
                        <!-- consularProcessing -->
                        <vs-checkbox name="consularProcessing"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'consularProcessing'})"
                          v-model="beneficiary.consularProcessing" class="w-full" label="">Consular Processing
                        </vs-checkbox>

                      </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full martb10 ">
                      <div class="main-placeholder right">
                        <!-- areYouUnderRemoveOfIndOrUscis -->
                        <vs-checkbox name="areYouUnderRemoveOfIndOrUscis"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'areYouUnderRemoveOfIndOrUscis'})"
                          v-model="beneficiary.areYouUnderRemoveOfIndOrUscis" class="w-full" label="">Are you currently under removal proceedings by the INS/USCIS?
                        </vs-checkbox>

                      </div>

                    </div>


                    

                  </div>
                  </div>
          </vs-col>      

            <template>
              <vs-col class="m-auto float-none demo-alignment beneficiary-info-btns pt-0" vs-type="flex"
                vs-justify="space-between" vs-align="center" vs-sm="12">
                <div class="vx-col w-full nowarp">
                  <vs-checkbox id="bengender" name="email"
                    @click="togleField({section:'beneficiary' ,subsection:'',field:'gender'})"
                    v-model="beneficiary.gender" class="w-full" label="Gender">Gender</vs-checkbox>
                </div>


              </vs-col>

              <div class="divider"></div>
            </template>
            <template>
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col w-full nowarp martb10">
                      <vx-input-group class="form-input-group">
                        <vs-checkbox id="beneficiary_firstname" name="firstname" v-model="beneficiary.first_name"
                          class="w-full" data-vv-as="First Name" label="First Name"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'first_name' ,})">First Name
                        </vs-checkbox>

                        <vs-checkbox id="beneficiary_middleName" class="w-full" name="middleName"
                          v-model="beneficiary.middle_name" data-vv-as="Middle Name" label="Middle Name"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'middle_name'})">Middle Name
                        </vs-checkbox>

                        <vs-checkbox id="beneficiary_lastName" class="w-full" name="lastName"
                          v-model="beneficiary.last_name" data-vv-as="Last Name" label="Last Name"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'last_name'})">Last Name
                        </vs-checkbox>
                      </vx-input-group>

                    </div>
                    <div class="vx-col w-full nowarp martb10">
                      <vx-input-group class="form-input-group">
                        <vs-checkbox id="benemail" name="ben_hasOtherNames"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_hasOtherNames'})"
                        v-model="beneficiary.ben_hasOtherNames" class="w-full" data-vv-as="Other Names" label="Have you ever used any other names previously?">Have you ever used any other names previously?
                      </vs-checkbox>
                    </vx-input-group>


                    </div>
                    <div class="vx-col w-full nowarp martb10">
                      
                      <vx-input-group class="form-input-group">
                        
                        <vs-checkbox id="benemail" name="email"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'email'})"
                          v-model="beneficiary.email" class="w-full" data-vv-as="Email" label="Email">Email
                        </vs-checkbox>

                        <vs-checkbox name="Date of Birth"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'dateOfBirth'})"
                          v-model="beneficiary.dateOfBirth" class="w-full" label="Date of Birth">Date of Birth
                        </vs-checkbox>

                        <vs-checkbox name="Marital Status"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'marital_status'})"
                          v-model="beneficiary.marital_status" class="w-full" label="Marital Status">Marital Status
                        </vs-checkbox>

                      </vx-input-group>
                    </div>

                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
            </template>
            <!--Phone Number Templaet--->
            <template>
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full martb10 ">
                      <div class="main-placeholder right">
                        <!-- cell_phone_number -->
                        <vs-checkbox name="Phone Number"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'cell_phone_number'})"
                          v-model="beneficiary.cell_phone_number" class="w-full" label="Phone Number">Phone Number
                        </vs-checkbox>

                      </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full martb10 ">
                      <!-- v-validate="'required|phonevalid'" -->
                      <div class="main-placeholder right">
                        <!-- cell_phone_number -->
                        <vs-checkbox name="Home Phone Number"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'home_phone_number'})"
                          v-model="beneficiary.home_phone_number" class="w-full" label="Home Phone Number">Home Phone
                          Number</vs-checkbox>

                      </div>
                    </div>


                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
            </template>

            <!--Education Templaet--->
            <template>
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container w-full">
                  <h3 class="small-header">Education</h3>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Highest Degree"
                          @click="togleField({section:'beneficiary' ,subsection:'education',field:'highest_degree'})"
                          v-model="beneficiary.education.highest_degree" class="w-full" label="Highest Degree">Highest
                          Degree</vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="Major Field of Study"
                          @click="togleField({section:'beneficiary' ,subsection:'education',field:'major_field_of_study'})"
                          v-model="beneficiary.education.major_field_of_study" class="w-full"
                          label="Major Field of Study">Major Field of Study</vs-checkbox>
                      </div>

                    </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
            </template>

            <template>

              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container w-full">
                  <h3 class="small-header"></h3>
                  <div class="vx-row">

                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Country Of Birth"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'countryOfBirth'})"
                          v-model="beneficiary.countryOfBirth" class="w-full" label="Country Of Birth">Country of Birth
                        </vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="Province Of Birth"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'provinceOfBirth'})"
                          v-model="beneficiary.provinceOfBirth" class="w-full" label="Province Of Birth">Province of
                          Birth</vs-checkbox>
                      </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="Province Of Birth"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'locationOfBirth'})"
                          v-model="beneficiary.locationOfBirth" class="w-full" label="Province Of Birth">Location of
                          Birth</vs-checkbox>
                      </div>

                    </div>

                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Country Of Citizenship"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'countryOfCitizenship'})"
                          v-model="beneficiary.countryOfCitizenship" class="w-full" label="Country Of Citizenship">
                          Country of Citizenship</vs-checkbox>
                      </div>
                    </div>
                    

                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="I94ExpiryDate"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'I94ExpiryDate'})"
                          v-model="beneficiary.I94ExpiryDate" class="w-full" label="I94ExpiryDate">I-94 Expiry Date
                        </vs-checkbox>
                      </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="I94" @click="togleField({section:'beneficiary' ,subsection:'',field:'I94'}) ;validateIp4ExpiryDate('beneficiary')"
                          v-model="beneficiary.I94" class="w-full" label="I94">I-94</vs-checkbox>
                      </div>
                      
                    </div>

                <div class="vx-col md:w-1/2 w-full martb5">

                <div class="main-placeholder right">
                <vs-checkbox name="I94StatusName" @click="togleField({section:'beneficiary' ,subsection:'',field:'I94StatusName'}) ;validateIp4ExpiryDate('beneficiary')"
                v-model="beneficiary.I94StatusName" class="w-full" label="I94 Status Name">I94 Status Name</vs-checkbox>
                </div>

                </div>

                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>


            </template>

            <template>

              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container w-full">
                  <h3 class="small-header">Passport</h3>
                  <div class="vx-row">

                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="passportNumber "
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'passportNumber'})"
                          v-model="beneficiary.passportNumber" class="w-full" label="Passport Number">Passport Number
                        </vs-checkbox>
                      </div>
                    </div>


                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Date Passport issued "
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'passportIssuedDate'})"
                          v-model="beneficiary.passportIssuedDate" class="w-full" label="Date Passport issued">Date of
                          Passport Issued </vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="passportExpiryDate "
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'passportExpiryDate'})"
                          v-model="beneficiary.passportExpiryDate" class="w-full" label="Passport Number">Date of
                          Passport Expires </vs-checkbox>
                      </div>
                    </div>


                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Date Of Visa Expires"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'curVisaExpiryDate'})"
                          v-model="beneficiary.curVisaExpiryDate" class="w-full" label="Date of Visa Expires">Date of
                          Visa Expires
                        </vs-checkbox>
                      </div>
                    </div>

                    <div class="vx-col md:w-1/2 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="passportIssuedCountry"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'passportIssuedCountry'})"
                          v-model="beneficiary.passportIssuedCountry" class="w-full" label="Passport issued Country">
                          Passport issued Country
                        </vs-checkbox>
                      </div>
                    </div>


                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="Current Nonimmigrant status"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'curNonImmigrantVisaStatus'})"
                          v-model="beneficiary.curNonImmigrantVisaStatus" class="w-full"
                          label="Current Nonimmigrant status">Current Nonimmigrant Status </vs-checkbox>
                      </div>

                    </div>

                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="SEVIS Number"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'sevisNumber'})"
                          v-model="beneficiary.sevisNumber" class="w-full" label="SEVIS Number">SEVIS Number
                        </vs-checkbox>
                      </div>

                    </div>

                    <div class="vx-col md:w-1/2 w-full martb5">

                      <div class="main-placeholder right">
                        <vs-checkbox name="EAD Number"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'eadNumber'})"
                          v-model="beneficiary.eadNumber" class="w-full" label="EAD Number">EAD Number</vs-checkbox>
                      </div>

                    </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>


            </template>
            <!-----New Fields-->
            <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
              <div class="form-container">

                <div class="vx-row martb10">

                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_haveOwnershipInterest'})"
                        v-model="beneficiary.ben_haveOwnershipInterest" class="w-full" label="Highest Degree">Do you
                        have ownership interest in this Company?</vs-checkbox>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_ownershipInterestDesc'})"
                        v-model="beneficiary.ben_ownershipInterestDesc" class="w-full" label="Highest Degree">Ownership
                        Interest Description</vs-checkbox>
                    </div>
                  </div>

                </div>


                <div class="vx-row martb10">

                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_consulateInfo'})"
                        v-model="beneficiary.ben_consulateInfo" class="w-full" label="Highest Degree">Consulate you want
                        to attend the visa interview?</vs-checkbox>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_alienNumber'})"
                        v-model="beneficiary.ben_alienNumber" class="w-full" label="Highest Degree">Alien Number
                      </vs-checkbox>
                    </div>
                  </div>

                </div>

                <div class="vx-row martb10">

                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_lastArrivalDate'})"
                        v-model="beneficiary.ben_lastArrivalDate" class="w-full" label="Highest Degree">Date of Last
                        Entry into USA</vs-checkbox>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_placeOfLastEntryInUS'})"
                        v-model="beneficiary.ben_placeOfLastEntryInUS" class="w-full" label="Highest Degree">Place of
                        Last Entry into USA</vs-checkbox>
                    </div>
                  </div>

                </div>


                <div class="vx-row martb10">

                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_educations'})"
                        v-model="beneficiary.ben_educations" class="w-full" label="Highest Degree">Educational
                        Background</vs-checkbox>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_nonImmPetitionsInfo'})"
                        v-model="beneficiary.ben_nonImmPetitionsInfo" class="w-full" label="Highest Degree">
                        Non-Immigrant Petitions Information</vs-checkbox>
                    </div>
                  </div>

                </div>

                <div class="vx-row martb10">

                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_anyImmPetitionFiled'})"
                        v-model="beneficiary.ben_anyImmPetitionFiled" class="w-full" label="Highest Degree">Is any
                        immigrant petition filed on your behalf</vs-checkbox>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full" v-if="false">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_immPetitionInfo'})"
                        v-model="beneficiary.ben_immPetitionInfo" class="w-full" label="Highest Degree">Immigrant
                        Petition Information</vs-checkbox>
                    </div>
                  </div>

                </div>

                <div class="vx-row martb10">

                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_prevEmploymentInfo'})"
                        v-model="beneficiary.ben_prevEmploymentInfo" class="w-full" label="Highest Degree">Previous
                        Employment Information</vs-checkbox>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="main-placeholder right">
                      <vs-checkbox name="Highest Degree"
                        @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_addressOutsideUS'})"
                        v-model="beneficiary.ben_addressOutsideUS" class="w-full" label="Highest Degree">Address Outside
                        the U.S</vs-checkbox>
                    </div>
                  </div>
                   <div class="vx-col md:w-1/2 w-full">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Highest Degree"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'ben_currentlyInUS'})"
                          v-model="beneficiary.ben_currentlyInUS" class="w-full" label="Highest Degree">Are you
                          currently in USA?</vs-checkbox>
                      </div>
                    </div>

                </div>


              </div>
            </vs-col>
            <div class="divider"></div>



            <!--Address Templaet--->
            <template>
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <h3 class="small-header">Address</h3>
                  <div class="vx-row martb10" v-if="false">
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Highest Degree"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'iam_from_us'})"
                          v-model="beneficiary.address.iam_from_us" class="w-full" label="Highest Degree">I am in the
                          United States</vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Major Field of Study"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'iam_notfrom_us'})"
                          v-model="beneficiary.address.iam_notfrom_us" class="w-full" label="Major Field of Study">I am
                          not in the United States</vs-checkbox>

                      </div>


                    </div>
                  </div>

                 

                  <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Street Address"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'beneficiary_address_line1'})"
                          v-model="beneficiary.address.beneficiary_address_line1" class="w-full" label="Street Address">
                          Street Address</vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Apt, Suite"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'beneficiary_address_line2'})"
                          v-model="beneficiary.address.beneficiary_address_line2" class="w-full" label="Apt, Suite">Apt,
                          Suite</vs-checkbox>
                      </div>
                    </div>

                    <div class="vx-col md:w-1/3 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Country"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'beneficiary_address_country'})"
                          v-model="beneficiary.address.beneficiary_address_country" class="w-full" label="Country">
                          Country</vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="State"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'beneficiary_address_state'})"
                          v-model="beneficiary.address.beneficiary_address_state" class="w-full" label="State">State
                        </vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="City"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'beneficiary_address_city'})"
                          v-model="beneficiary.address.beneficiary_address_city" class="w-full" label="City">City
                        </vs-checkbox>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="zipcode"
                          @click="togleField({section:'beneficiary' ,subsection:'address',field:'beneficiary_address_zipcode'})"
                          v-model="beneficiary.address.beneficiary_address_zipcode" class="w-full" label="Zip code">Zip
                          Code</vs-checkbox>
                      </div>
                    </div>
                  </div>
                  <h3 class="small-header">Malling Address</h3>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="Malling Address"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'mailingAddress'})"
                          v-model="beneficiary.mailingAddress" class="w-full" label="Malling Address">
                          Malling Address</vs-checkbox>
                      </div>
                    </div>

                  </div>

                </div>
              </vs-col>
              <div class="divider"></div>
            </template>

            <template>
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col w-full martb10">
                      <vs-checkbox name="ssn" @click="togleField({section:'beneficiary' ,subsection:'',field:'SSN'})"
                        v-model="beneficiary.SSN" class="w-full" label="ssn">Social Security number (if applicable)
                      </vs-checkbox>
                    </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider" v-if="!beneficiary.address.iam_from_us"> </div>
            </template>
            <template>


              <vs-col v-if="!beneficiary.address.iam_from_us" class="m-auto float-none" vs-type="flex"
                vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col w-full martb5">
                      <div class="main-placeholder right">
                        <vs-checkbox name="consulateNotifyAddress"
                          @click="togleField({section:'beneficiary' ,subsection:'',field:'consulateNotifyAddress'})"
                          v-model="beneficiary.consulateNotifyAddress" class="w-full">Consulate to Notify upon Approval
                          of your petition (if outside the USA)</vs-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
            </template>
            <template>
              <vs-col class="m-auto float-none" vs-sm="12">

                <div class="martb5">
                  <div class="main-placeholder right ">
                    <vs-checkbox name="hasI140ImmPetitionFiled"
                      @click="togleField({section:'beneficiary' ,subsection:'',field:'hasI140ImmPetitionFiled'})"
                      v-model="beneficiary.hasI140ImmPetitionFiled" class="w-full">Has an I-140 immigrant petition been
                      filed on your behalf? </vs-checkbox>
                  </div>

                  <div class="form-container mt-6" v-if="beneficiary.hasI140ImmPetitionFiled ">
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="main-placeholder right">
                          <vs-checkbox name="docs_i140_approval_notice"
                            @click="togleField({section:'beneficiary' ,subsection:'',field:'docs_i140_approval_notice'})"
                            v-model="beneficiary.docs_i140_approval_notice" class="w-full">I-140 Approval Notice
                            documents, if any</vs-checkbox>
                        </div>


                      </div>

                    </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
            </template>

            <template>
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">

                    <div class="vx-col w-full martb5">

                      <div class="vx-row delete-row">
                        <div class="vx-col  w-full">
                          <div class="main-placeholder right">
                            <vs-checkbox name="priorPeriodOfStayInUS"
                              @click="togleField({section:'beneficiary' ,subsection:'',field:'priorPeriodOfStayInUS'})"
                              v-model="beneficiary.priorPeriodOfStayInUS" class="w-full">All prior periods of stay in
                              the U.S. over the last seven years</vs-checkbox>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

              </vs-col>

            </template>

          </form>
        </div>
      </div>
    </div>
    <div>
      <div class="block_title pb-0 pt-8">
        Documents
      </div>
      <div>
        <div :before-change="beforedocumentsTabSwitch">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container w-full">
              <h3 class="small-header">
                List of documents needs to be updated
                <span class="file-type">
                  (File Type: PDF,
                  DOC, JPEG, PNG. Max
                  file size: 1MB)
                </span>
              </h3>
              <div class="vx-row">

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_passport"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_passport'})"
                      v-model="beneficiary.documents.docs_passport" class="w-full">Passport, along with Case and Form
                      I-94 (clearly showing the dates of
                      first and last entry into the United States)</vs-checkbox>
                  </div>
                </div>


                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_passport_visa_i94"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_passport_visa_i94'})"
                      v-model="beneficiary.documents.docs_passport_visa_i94" class="w-full"> {{ "passportVisaI94" |
                      formatdoctype }}</vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_resume"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_resume'})"
                      v-model="beneficiary.documents.docs_resume" class="w-full">Resume</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_education"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_education'})"
                      v-model="beneficiary.documents.docs_education" class="w-full">{{'education' | formatdoctype}}
                    </vs-checkbox>
                  </div>

                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_exp_letters"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_exp_letters'})"
                      v-model="beneficiary.documents.docs_exp_letters" class="w-full">Experience Letters</vs-checkbox>
                  </div>


                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_ins_notices"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_ins_notices'})"
                      v-model="beneficiary.documents.docs_ins_notices" class="w-full">{{ "INSNotices" | formatdoctype }}
                    </vs-checkbox>
                  </div>
                </div>


                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_form_i20_ead"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_form_i20_ead'})"
                      v-model="beneficiary.documents.docs_form_i20_ead" class="w-full">{{ "formI20" | formatdoctype }}
                    </vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_I797NoticeofApprovalforI140"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_I797NoticeofApprovalforI140'})"
                      v-model="beneficiary.documents.docs_I797NoticeofApprovalforI140" class="w-full">{{
                      "I797NoticeofApprovalforI140" | formatdoctype }}</vs-checkbox>
                  </div>
                </div>


                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_ead"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_ead'})"
                      v-model="beneficiary.documents.docs_ead" class="w-full">EADs (if on OPT or STEM OPT Extension)
                    </vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_ssc_licence"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_ssc_licence'})"
                      v-model="beneficiary.documents.docs_ssc_licence" class="w-full">Social security card and state
                      professional license</vs-checkbox>
                  </div>
                </div>




                <!----NEW DOCUMENTS--->

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_paystubs"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_paystubs'})"
                      v-model="beneficiary.documents.docs_paystubs" class="w-full">Three Recent Pay Stubs</vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_offer_letters"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_offer_letters'})"
                      v-model="beneficiary.documents.docs_offer_letters" class="w-full">Employment Offer Letter
                    </vs-checkbox>
                  </div>
                </div>

                <!-- <div class="vx-col w-full martb5"> 
                 <div class="main-placeholder right">
                  <vs-checkbox   name="docs_employmentAggrementLatters" @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_employmentAggrementLatters'})" v-model="beneficiary.documents.docs_employmentAggrementLatters" class="w-full"
                    >Employment Agreement Letter</vs-checkbox>
                </div>
                </div> -->
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_employment_agreement"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_employment_agreement'})"
                      v-model="beneficiary.documents.docs_employment_agreement" class="w-full">Employment Agreement
                      Letter</vs-checkbox>
                  </div>
                </div>

                <!-- Client Letters -->
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_client_letters"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_client_letters'})"
                      v-model="beneficiary.documents.docs_client_letters" class="w-full">Client Letters</vs-checkbox>
                  </div>

                </div>


                <!--vendorLetter--->
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_vendor_letters"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_vendor_letters'})"
                      v-model="beneficiary.documents.docs_vendor_letters" class="w-full">Vendor Letters</vs-checkbox>
                  </div>
                </div>


                <!--msa--->
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_msa"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_msa'})"
                      v-model="beneficiary.documents.docs_msa" class="w-full">{{ 'msa' | formatdoctype}} </vs-checkbox>
                  </div>
                </div>

                <!--po--->
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_po"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_po'})"
                      v-model="beneficiary.documents.docs_po" class="w-full">PO</vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_h1b_reg_selection_notice"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_h1b_reg_selection_notice'})"
                      v-model="beneficiary.documents.docs_h1b_reg_selection_notice" class="w-full">{{
                      "h1bRegSelectionNotice" | formatdoctype
                      }}</vs-checkbox>
                  </div>
                </div>


                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_prime_vendor"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_prime_vendor'})"
                      v-model="beneficiary.documents.docs_prime_vendor" class="w-full">Prime Vendor Letter (if
                      applicable)</vs-checkbox>
                  </div>
                </div>


                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_form_i94"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_form_i94'})"
                      v-model="beneficiary.documents.docs_form_i94" class="w-full">I-94</vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_prior_form_i797"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_prior_form_i797'})"
                      v-model="beneficiary.documents.docs_prior_form_i797" class="w-full">{{ "priorFormI797" |
                      formatdoctype }}</vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgResume"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgResume'})"
                      v-model="beneficiary.documents.slgResume" class="w-full">SLG - {{ "slgResume" | formatdoctype }}
                    </vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgCollegeDegreesCert"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgCollegeDegreesCert'})"
                      v-model="beneficiary.documents.slgCollegeDegreesCert" class="w-full">SLG - {{ "slgCollegeDegreesCert" |
                      formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgTransScripts"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgTransScripts'})"
                      v-model="beneficiary.documents.slgTransScripts" class="w-full">SLG -{{ "slgTransScripts" |
                      formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgExpLetters"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgExpLetters'})"
                      v-model="beneficiary.documents.slgExpLetters" class="w-full">SLG -{{ "slgExpLetters" | formatdoctype }}
                    </vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgPassportAndVisa"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgPassportAndVisa'})"
                      v-model="beneficiary.documents.slgPassportAndVisa" class="w-full">SLG -{{ "slgPassportAndVisa" |
                      formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgI94"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgI94'})"
                      v-model="beneficiary.documents.slgI94" class="w-full">SLG -{{ "slgI94" | formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgPrevNonimmApprovalNotices"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgPrevNonimmApprovalNotices'})"
                      v-model="beneficiary.documents.slgPrevNonimmApprovalNotices" class="w-full">SLG -{{
                      "slgPrevNonimmApprovalNotices" | formatdoctype }}</vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgI140OrPermNoties"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgI140OrPermNoties'})"
                      v-model="beneficiary.documents.slgI140OrPermNoties" class="w-full">SLG -{{ "slgI140OrPermNoties" |
                      formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgPrevLaborApplications"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgPrevLaborApplications'})"
                      v-model="beneficiary.documents.slgPrevLaborApplications" class="w-full">SLG -{{
                      "slgPrevLaborApplications" | formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgAckOfPrevLaborApplications"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgAckOfPrevLaborApplications'})"
                      v-model="beneficiary.documents.slgAckOfPrevLaborApplications" class="w-full">SLG -{{
                      "slgAckOfPrevLaborApplications" | formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgPaystubs"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgPaystubs'})"
                      v-model="beneficiary.documents.slgPaystubs" class="w-full">SLG -{{ "slgPaystubs" | formatdoctype }}
                    </vs-checkbox>
                  </div>
                </div>

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgI20"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgI20'})"
                      v-model="beneficiary.documents.slgI20" class="w-full">SLG -{{ "slgI20" | formatdoctype }}</vs-checkbox>
                  </div>
                </div>
                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="slgEad"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'slgEad'})"
                      v-model="beneficiary.documents.slgEad" class="w-full">SLG -{{ "slgEad" | formatdoctype }}</vs-checkbox>
                  </div>
                </div>





                <!----NEW DOCUMENTS END--->

                <div class="vx-col w-full martb5">
                  <div class="main-placeholder right">
                    <vs-checkbox name="docs_other"
                      @click="togleField({section:'beneficiary' ,subsection:'documents',field:'docs_other'})"
                      v-model="beneficiary.documents.docs_other" class="w-full">Other documents, if any</vs-checkbox>
                  </div>
                </div>


              </div>
            </div>
          </vs-col>
          <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
        </div>
      </div>
    </div>
    <div v-if="beneficiary.marital_status">
      <div class="block_title pb-2 pt-8">
        Spouse Info
      </div>
      <div>

        <form data-vv-scope="dependentsInfoform" @submit.prevent="" @keydown.enter.prevent="">

          <!-- <vs-col class="w-full p-0">
            <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">
              <p>
                Your spouse and children will need to apply for H-4 status (only if they are currently in the USA on a
                valid status).
              </p>
              <p>
                That their status must be extended through a separate application, and is not automatically extended
                upon approval of the H-1B petition.
              </p>
            </vs-alert>
          </vs-col> -->

          <div class="spousedetails">
            <vs-col class="m-auto pt-0 float-none" vs-type="flex" vs-sm="12">
              <div class="martb10">
                <div class="main-placeholder right">
                  <vs-checkbox name="h4Required"
                    @click="togleField({section:'spouse' ,subsection:'',field:'spouse_h4_required'})"
                    v-model="spouse.spouse_h4_required" class="w-full">H4 required for spouse?</vs-checkbox>
                </div>
              </div>
            </vs-col>

            <template>


            </template>

            <div v-if="spouse.spouse_h4_required && spouse.spouse_h4_required == true">

              <div class="divider" v-if="spouse.spouse_h4_required && spouse.spouse_h4_required == true">
              </div>
              <vs-col v-if="spouse.spouse_h4_required && spouse.spouse_h4_required == true" class="m-auto float-none"
                vs-type="flex" vs-sm="12">

                <div class="main-placeholder right martb10">
                  <vs-checkbox name="spouse_h4_ead_required"
                    @click="togleField({section:'spouse' ,subsection:'',field:'spouse_h4_ead_required'})"
                    v-model="spouse.spouse_h4_ead_required" class="w-full">H4 EAD required for spouse?</vs-checkbox>
                </div>
                <!--
              <vs-button v-bind:class="{
                cactive: dependentsInfo.spouse.h4Required === true && dependentsInfo.spouse.h4EADRequired === true
              }" @click="setH4EADValue(dependentsInfo.spouse.h4Required, true)" class="mr-5" color="success" type="border">Yes
              </vs-button>
              <vs-button v-bind:class="{
                cactive: dependentsInfo.spouse.h4Required === true && dependentsInfo.spouse.h4EADRequired === false
              }" @click="setH4EADValue(dependentsInfo.spouse.h4Required, false)" color="danger" type="border">No</vs-button>

              -->

              </vs-col>
              <div class="divider" v-if="spouse.spouse_h4_required || spouse.spouse_h4_ead_required"></div>

              <template>

                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container">
                    <div class="vx-row">
                      <template>
                        <div class="vx-col w-full martb10">
                          <div class="main-placeholder right">
                            <vx-input-group class="form-input-group">
                              <vs-checkbox name="spouse_first_name"
                                @click="togleField({section:'spouse' ,subsection:'',field:'spouse_first_name'})"
                                v-model="spouse.spouse_first_name" class="w-full">First Name</vs-checkbox>

                              <vs-checkbox name="spouse_middle_name"
                                @click="togleField({section:'spouse' ,subsection:'',field:'spouse_middle_name'})"
                                v-model="spouse.spouse_middle_name" class="w-full">Middle Name</vs-checkbox>

                              <vs-checkbox name="spouse_last_name"
                                @click="togleField({section:'spouse' ,subsection:'',field:'spouse_last_name'})"
                                v-model="spouse.spouse_last_name" class="w-full">Last Name</vs-checkbox>

                            </vx-input-group>
                          </div>

                        </div>
                      </template>

                      <!------------ NEW SPOUSE START---- -->
                      <div class="vx-col md:w-full w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_email"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spo_relationship'})"
                            v-model="spouse.spo_relationship" class="w-full">Your Relationship with the dependent.
                            (E.g., Spouse/Son/Daughter etc.)</vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spo_currentlyInUS'})"
                            v-model="spouse.spo_currentlyInUS" class="w-full" label="Highest Degree">Are you currently
                            in USA?</vs-checkbox>
                        </div>
                      </div>



                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spo_hasOtherNames'})"
                            v-model="spouse.spo_hasOtherNames" class="w-full" label="Highest Degree">List any other
                            name(s) used (on certificates, by marriage etcetra)?</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spo_passportIssuedDate'})"
                            v-model="spouse.spo_passportIssuedDate" class="w-full" label="Highest Degree"> Date of
                            Passport Issued</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spo_alienNumber'})"
                            v-model="spouse.spo_alienNumber" class="w-full" label="Highest Degree">Alien Number
                          </vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spo_addressOutsideUS'})"
                            v-model="spouse.spo_addressOutsideUS" class="w-full" label="Highest Degree">Address Outside
                            the U.S</vs-checkbox>
                        </div>
                      </div>



                      <!------------ NEW SPOUSE END---- -->

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_email"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_email'})"
                            v-model="spouse.spouse_email" class="w-full">Spouse Email</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="vs-component vs-input w-full vs-input-primary">
                          <div class="main-placeholder right">
                            <vs-checkbox name="spouse_phone_number"
                              @click="togleField({section:'spouse' ,subsection:'',field:'spouse_phone_number'})"
                              v-model="spouse.spouse_phone_number" class="w-full">Spouse Phone Number</vs-checkbox>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_dob"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_dob'})"
                            v-model="spouse.spouse_dob" class="w-full">Spouse’s Date of Birth</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="w-full select-large">
                          <div class="main-placeholder right">
                            <vs-checkbox name="spouse_cob"
                              @click="togleField({section:'spouse' ,subsection:'',field:'spouse_cob'})"
                              v-model="spouse.spouse_cob" class="w-full">Country of Birth</vs-checkbox>
                          </div>
                        </div>

                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="w-full select-large">
                          <div class="main-placeholder right">
                            <vs-checkbox name="spouse_provinceOfBirth"
                              @click="togleField({section:'spouse' ,subsection:'',field:'spouse_provinceOfBirth'})"
                              v-model="spouse.spouse_provinceOfBirth" class="w-full">Province of Birth</vs-checkbox>
                          </div>
                        </div>

                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="w-full select-large">
                          <div class="main-placeholder right">
                            <vs-checkbox name="spouse_locationOfBirth"
                              @click="togleField({section:'spouse' ,subsection:'',field:'spouse_locationOfBirth'})"
                              v-model="spouse.spouse_locationOfBirth" class="w-full">Location of Birth</vs-checkbox>
                          </div>
                        </div>

                      </div>




                    </div>
                  </div>
                </vs-col>
                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container">
                    <div class="vx-row">

                      <div class="vx-col w-full martb5">

                        <div class="vx-row delete-row">
                          <div class="vx-col  w-full">
                            <div class="main-placeholder right">
                              <vs-checkbox name="spo_priorPeriodOfStayInUS"
                                @click="togleField({section:'spouse' ,subsection:'',field:'spo_priorPeriodOfStayInUS'})"
                                v-model="spouse.spo_priorPeriodOfStayInUS" class="w-full">All prior periods of stay in
                                the U.S. over the last seven years</vs-checkbox>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </vs-col>
                <div class="divider"></div>
              </template>

              <template>

                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container">
                    <div class="vx-row">
                      <div class="vx-col lg:w-1/2 md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_passport_number"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_passport_number'})"
                            v-model="spouse.spouse_passport_number" class="w-full">{{ 'passport'| formatdoctype }}
                          </vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col lg:w-1/2 md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_passport_expiry_date"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_passport_expiry_date'})"
                            v-model="spouse.spouse_passport_expiry_date" class="w-full">Date of Passport Expiry
                          </vs-checkbox>
                        </div>
                      </div>


                    </div>
                  </div>
                </vs-col>
                <div class="divider"></div>
              </template>

              <template>

                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container">
                    <div class="vx-row">

                      <div class="vx-col lg:w-1/2 md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_i94"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_i94'});validateIp4ExpiryDate('spouse')"
                            v-model="spouse.spouse_i94" class="w-full">I-94</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb5" >

                        <div class="main-placeholder right">
                          <vs-checkbox name="spo_I94ExpiryDate"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spo_I94ExpiryDate'});"
                            v-model="spouse.spo_I94ExpiryDate" class="w-full" label="spo_I94ExpiryDate">I-94 Expiry Date
                          </vs-checkbox>
                        </div>
  
                      </div>
                      <div class="vx-col lg:w-1/2 md:w-1/2 w-full martb10">

                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_country_of_citizenship"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_country_of_citizenship'})"
                            v-model="spouse.spouse_country_of_citizenship" class="w-full">Country of Citizenship
                          </vs-checkbox>
                        </div>


                      </div>
                    </div>
                  </div>
                </vs-col>
                <div class="divider"></div>
              </template>

              <template>


                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container">
                    <div class="vx-row">
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_current_status"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_current_status'})"
                            v-model="spouse.spouse_current_status" class="w-full">Spouse’s current status </vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_status_expiry_date"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_status_expiry_date'})"
                            v-model="spouse.spouse_status_expiry_date" class="w-full">When does spouse’s status expires
                          </vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_ssn"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_ssn'})"
                            v-model="spouse.spouse_ssn" class="w-full">Spouse’s social security (if Any)</vs-checkbox>
                        </div>

                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_date_of_last_arrival"
                            @click="togleField({section:'spouse' ,subsection:'',field:'spouse_date_of_last_arrival'})"
                            v-model="spouse.spouse_date_of_last_arrival" class="w-full">Date of last arrival
                          </vs-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                <div class="divider"></div>
              </template>

              <template>

                <vs-col class="m-auto float-none" vs-sm="12">
                  <div class="form-container">
                    <h3 class="small-header">Physical Address</h3>
                    <div class="vx-row">

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Street Address"
                            @click="togleField({section:'spouse' ,subsection:'address',field:'spouse_address_line2'})"
                            v-model="spouse.address.spouse_address_line2" class="w-full" label="Street Address">Street
                            Address</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Apt, Suite"
                            @click="togleField({section:'spouse' ,subsection:'address',field:'spouse_address_line1'})"
                            v-model="spouse.address.spouse_address_line1" class="w-full" label="Apt, Suite">Apt, Suite
                          </vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Country"
                            @click="togleField({section:'spouse' ,subsection:'address',field:'spouse_address_country'})"
                            v-model="spouse.address.spouse_address_country" class="w-full" label="Country">Country
                          </vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="State"
                            @click="togleField({section:'spouse' ,subsection:'address',field:'spouse_address_state'})"
                            v-model="spouse.address.spouse_address_state" class="w-full" label="State">State
                          </vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="City"
                            @click="togleField({section:'spouse' ,subsection:'address',field:'spouse_address_city'})"
                            v-model="spouse.address.spouse_address_city" class="w-full" label="City">City</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="zipcode"
                            @click="togleField({section:'spouse' ,subsection:'address',field:'spouse_address_zipcode'})"
                            v-model="spouse.address.spouse_address_zipcode" class="w-full" label="Zip code">Zip Code
                          </vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col md:w-1/2 w-full">

                      </div>
                    </div>
                  </div>
                </vs-col>
                <div class="divider"></div>
              </template>

              <template>
                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container w-full">
                    <div class="mb-8">
                      <vs-alert active="true" class="h-auto warning-alert mb-5" icon-pack="IntakePortal"
                        icon="IP-information-button">
                        Provide copies of the following spouse documents: Case, Form I-94, Form I-797, Marriage
                        Certificate
                      </vs-alert>
                    </div>
                    <h3 class="small-header">
                      Spouse Documents
                      <span class="file-type">
                        (File Type: PDF, DOC, JPEG, PNG. Max
                        file size: 1MB)
                      </span>
                    </h3>
                    <div class="vx-row">
                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_passport"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_passport'})"
                            v-model="spouse.documents.spouse_docs_passport" class="w-full" label="Passport">{{"passport"
                            | formatdoctype}}</vs-checkbox>
                        </div>



                      </div>

                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_visa"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_visa'})"
                            v-model="spouse.documents.spouse_docs_visa" class="w-full" label="Visa">Visa</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col w-full martb5">
                        <!-- check balu 2 -->
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_formi94"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_formi94'})"
                            v-model="spouse.documents.spouse_docs_formi94" class="w-full" label="spouse_docs_form_I94">
                            Form I-94</vs-checkbox>
                        </div>


                      </div>
                      <div class="vx-col w-full martb5">
                        <!-- check balu 3 -->
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_form_i797"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_form_i797'})"
                            v-model="spouse.documents.spouse_docs_form_i797" class="w-full"
                            label="spouse_docs_form_i797">Latest I-797, Notice of Approval of the spouse (if
                            spouse is on H-1B or L-1 status)</vs-checkbox>
                        </div>


                      </div>
                      <div class="vx-col w-full martb5">
                        <!-- check balu 4 -->
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_mrg_certificate"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_mrg_certificate'})"
                            v-model="spouse.documents.spouse_docs_mrg_certificate" class="w-full"
                            label="spouse_docs_mrg_certificate">{{'marriageCertificate' | formatdoctype}}</vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col w-full martb5">
                        <!-- check balu 4 -->
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_form_i20"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_form_i20'})"
                            v-model="spouse.documents.spouse_docs_form_i20" class="w-full" label="spouse_docs_form_i20">
                            Spouse’s all Form I-20s (if spouse is on F-1 status)</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col w-full martb5">
                        <!-- check balu 4 -->
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_pay_stubs"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_pay_stubs'})"
                            v-model="spouse.documents.spouse_docs_pay_stubs" class="w-full"
                            label="spouse_docs_pay_stubs">Three Recent Pay Stubs</vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">

                          <vs-checkbox id="spouse_docs_noticeOfApprovalOfH1Status" class="w-full" name="spouse_docs_noticeOfApprovalOfH1Status"
                            v-model="spouse.documents.spouse_docs_noticeOfApprovalOfH1Status"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_noticeOfApprovalOfH1Status'})">
                            {{'noticeOfApprovalOfH1Status' | formatdoctype }}</vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">

                          <vs-checkbox id="spouse_docs_approvalNoticeOfPrevH4" class="w-full" name="spouse_docs_approvalNoticeOfPrevH4"
                            v-model="spouse.documents.spouse_docs_approvalNoticeOfPrevH4"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_approvalNoticeOfPrevH4'})">
                            {{'approvalNoticeOfPrevH4' | formatdoctype }}</vs-checkbox>
                        </div>
                      </div>



                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_docs_other"
                            @click="togleField({section:'spouse' ,subsection:'documents',field:'spouse_docs_other'})"
                            v-model="spouse.documents.spouse_docs_other" class="w-full" label="spouse_docs_other">Other
                            documents, if any</vs-checkbox>
                        </div>

                      </div>

                    </div>
                  </div>
                </vs-col>
              </template>
            </div>



          </div>

          <div class="pb-12">

            <div class="divider"></div>
            <div class="block_title pb-3">
              Children Info
            </div>
            <vs-col class="m-auto float-none" vs-type="flex" vs-sm="12">
              <div class="martb10">

                <div class="main-placeholder right">
                  <vs-checkbox name="childeren_h4Required"
                    @click="togleField({section:'children' ,subsection:'',field:'child_h4_required'})"
                    v-model="children.child_h4_required" class="w-full" label="h4Required">H4 required for children?
                  </vs-checkbox>
                </div>

              </div>
            </vs-col>

            <div v-if="children.child_h4_required == true ">
              <template>
                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container">
                    <div class="vx-row">
                      <div class="vx-col w-full martb10">
                        <div class="vx-col w-full nowarp">
                          <vx-input-group class="form-input-group">
                            <vs-checkbox id="children_firstname" name="firstname" v-model="children.child_first_name"
                              class="w-full" data-vv-as="First Name" label="First Name"
                              @click="togleField({section:'children' ,subsection:'',field:'child_first_name' ,})">First
                              Name</vs-checkbox>

                            <vs-checkbox id="child_middle_name" class="w-full" name="middleName"
                              v-model="children.child_middle_name" data-vv-as="Middle Name" label="Middle Name"
                              @click="togleField({section:'children' ,subsection:'',field:'child_middle_name'})">Middle
                              Name</vs-checkbox>

                            <vs-checkbox id="child_last_name" class="w-full" name="lastName"
                              v-model="children.child_last_name" data-vv-as="Last Name" label="Last Name"
                              @click="togleField({section:'children' ,subsection:'',field:'child_last_name'})">Last Name
                            </vs-checkbox>
                          </vx-input-group>

                        </div>
                        <div class="input-group-error">
                          <p class="w-1/3">
                            <span class="text-danger text-sm" v-show="errors.has('dependentsInfoform.childname'+index)">
                              {{ errors.first("dependentsInfoform.childname"+index) }}
                            </span>
                          </p>
                          <p class="w-1/3">
                          </p>
                          <p class="w-1/3">
                            <span class="text-danger text-sm"
                              v-show="errors.has('dependentsInfoform.last_childname'+index)">
                              {{ errors.first("dependentsInfoform.last_childname"+index) }}
                            </span>
                          </p>
                        </div>
                      </div>


                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_dob" class="w-full" name="child_dob" v-model="children.child_dob"
                            @click="togleField({section:'children' ,subsection:'',field:'child_dob'})">Child’s Date of
                            Birth</vs-checkbox>

                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class=" w-full select-large">
                          <vs-checkbox id="child_cob" class="w-full" name="child_cob" v-model="children.child_cob"
                            @click="togleField({section:'children' ,subsection:'',field:'child_cob'})">Country of Birth
                          </vs-checkbox>

                        </div>

                      </div>


                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class=" w-full select-large">
                          <vs-checkbox id="child_passport_number" class="w-full" name="child_passport_number"
                            v-model="children.child_passport_number"
                            @click="togleField({section:'children' ,subsection:'',field:'child_passport_number'})">
                            Children Passport Number</vs-checkbox>

                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">

                        <div class="main-placeholder right">

                          <vs-checkbox id="child_passport_expiry_date" class="w-full" name="child_passport_expiry_date"
                            v-model="children.child_passport_expiry_date"
                            @click="togleField({section:'children' ,subsection:'',field:'child_passport_expiry_date'})">
                            Date of Passport Expiry </vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_i94" class="w-full" name="child_i94" v-model="children.child_i94"
                            @click="togleField({section:'children' ,subsection:'',field:'child_i94'});validateIp4ExpiryDate('children')">Child’s I –94
                          </vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_i94_expiry_date" class="w-full" name="child_i94_expiry_date" v-model="children.child_i94_expiry_date"
                            @click="togleField({section:'children' ,subsection:'',field:'child_i94_expiry_date'})">I-94 Expiry Date
                          </vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="w-full select-large">
                          <div class="main-placeholder right">

                            <vs-checkbox id="child_country_of_citizenship" class="w-full"
                              name="child_country_of_citizenship" v-model="children.child_country_of_citizenship"
                              @click="togleField({section:'children' ,subsection:'',field:'child_country_of_citizenship'})">
                              Country of Citizenship</vs-checkbox>
                          </div>

                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_current_status" class="w-full" name="child_current_status"
                            v-model="children.child_current_status"
                            @click="togleField({section:'children' ,subsection:'',field:'child_current_status'})">Case
                            Status</vs-checkbox>
                        </div>


                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_status_expiry_date" class="w-full" name="child_status_expiry_date"
                            v-model="children.child_status_expiry_date"
                            @click="togleField({section:'children' ,subsection:'',field:'child_status_expiry_date'})">
                            When does child’s status expires</vs-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container">
                    <div class="vx-row">

                      <div class="vx-col w-full martb5">

                        <div class="vx-row delete-row">
                          <div class="vx-col  w-full">
                            <div class="main-placeholder right">
                              <vs-checkbox name="spo_priorPeriodOfStayInUS"
                                @click="togleField({section:'children' ,subsection:'',field:'chi_priorPeriodOfStayInUS'})"
                                v-model="children.chi_priorPeriodOfStayInUS" class="w-full">All prior periods of stay in
                                the U.S. over the last seven years</vs-checkbox>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                    <div class="vx-row">

                      <!------------ NEW SPOUSE START---- -->
                      <div class="vx-col md:w-full w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="spouse_email"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_relationship'})"
                            v-model="children.chi_relationship" class="w-full">Your Relationship with the dependent.
                            (E.g., Spouse/Son/Daughter etc.)</vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_currentlyInUS'})"
                            v-model="children.chi_currentlyInUS" class="w-full" label="Highest Degree">Are you currently
                            in USA?</vs-checkbox>
                        </div>
                      </div>



                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_hasOtherNames'})"
                            v-model="children.chi_hasOtherNames" class="w-full" label="Highest Degree">List any other
                            name(s) used (on certificates, by marriage etcetra)?</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_passportIssuedDate'})"
                            v-model="children.chi_passportIssuedDate" class="w-full" label="Highest Degree"> Date of
                            Passport Issued</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_alienNumber'})"
                            v-model="children.chi_alienNumber" class="w-full" label="Highest Degree">Alien Number
                          </vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_addressOutsideUS'})"
                            v-model="children.chi_addressOutsideUS" class="w-full" label="Highest Degree">Address
                            Outside the U.S</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_lastArrivalDate'})"
                            v-model="children.chi_lastArrivalDate" class="w-full" label="Highest Degree">Date of Last
                            Entry into USA</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_placeOfLastEntryInUS'})"
                            v-model="children.chi_placeOfLastEntryInUS" class="w-full" label="Highest Degree">Place of
                            Last Entry into USA</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full martb10">
                        <div class="main-placeholder right">
                          <vs-checkbox name="Highest Degree"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_physicalAddress'})"
                            v-model="children.chi_physicalAddress" class="w-full" label="Highest Degree">Address
                          </vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full martb5">

                        <div class="main-placeholder right">
                          <vs-checkbox name="Province of Birth"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_provinceOfBirth'})"
                            v-model="children.chi_provinceOfBirth" class="w-full" label="Province Of Birth">Province of
                            Birth</vs-checkbox>
                        </div>

                      </div>
                      <div class="vx-col md:w-1/2 w-full martb5">

                        <div class="main-placeholder right">
                          <vs-checkbox name="Province of Birth"
                            @click="togleField({section:'children' ,subsection:'',field:'chi_locationOfBirth'})"
                            v-model="children.chi_locationOfBirth" class="w-full" label="Province of Birth">Location of
                            Birth</vs-checkbox>
                        </div>

                      </div>



                      <!------------ NEW SPOUSE END---- -->


                    </div>

                  </div>

                </vs-col>
                <div class="divider"></div>
              </template>
              <template>
                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                  <div class="form-container w-full">
                    <div class="alert-content-block">
                      <vs-alert active="true" class="h-auto warning-alert mb-5" icon-pack="IntakePortal"
                        icon="IP-information-button">
                        Provide copies of the following children documents: Case, Form I-94, Form I-797, Birth
                        Certificate.
                      </vs-alert>
                    </div>
                    <h3 class="small-header">
                      Child's Documents
                      <span class="file-type">
                        (File Type: PDF, DOC, JPEG, PNG. Max
                        file size: 1MB)
                      </span>
                    </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_docs_passport" class="w-full" name="child_docs_passport"
                            v-model="children.documents.child_docs_passport"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_passport'})">
                            {{"passport" | formatdoctype}}</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_docs_visa" class="w-full" name="child_docs_visa"
                            v-model="children.documents.child_docs_visa"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_visa'})">
                            Case</vs-checkbox>
                        </div>
                      </div>
                      <div class="vx-col w-full martb5">

                        <div class="main-placeholder right">
                          <vs-checkbox id="child_docs_form_i94" class="w-full" name="child_docs_form_i94"
                            v-model="children.documents.child_docs_form_i94"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_form_i94'})">
                            Form I-94</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_docs_form_i797" class="w-full" name="child_docs_form_i797"
                            v-model="children.documents.child_docs_form_i797"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_form_i797'})">
                            Form I-797</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">

                          <vs-checkbox id="child_docs_approvalNoticeOfPrevH4" class="w-full" name="child_docs_approvalNoticeOfPrevH4"
                            v-model="children.documents.child_docs_approvalNoticeOfPrevH4"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_approvalNoticeOfPrevH4'})">
                            {{'approvalNoticeOfPrevH4' | formatdoctype }}</vs-checkbox>
                        </div>
                      </div>

                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">
                          <vs-checkbox id="child_docs_birth_certificate" class="w-full"
                            name="child_docs_birth_certificate"
                            v-model="children.documents.child_docs_birth_certificate"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_birth_certificate'})">
                            Birth Certificate</vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">
                          <vs-checkbox id="child_docs_approval_notice" class="w-full" name="child_docs_approval_notice"
                            v-model="children.documents.child_docs_approval_notice"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_approval_notice'})">
                            Approval Notice</vs-checkbox>
                        </div>
                      </div>


                      <div class="vx-col w-full martb5">
                        <div class="main-placeholder right">
                          <vs-checkbox id="child_docs_other" class="w-full" name="child_docs_other"
                            v-model="children.documents.child_docs_other"
                            @click="togleField({section:'children' ,subsection:'documents',field:'child_docs_other'})">
                            Other documents, if any</vs-checkbox>
                        </div>
                      </div>


                    </div>
                  </div>
                </vs-col>
              </template>
            </div>


            <vs-col v-if="children.child_h4_required == true" class="m-auto float-none" vs-type="flex" vs-align="center"
              vs-sm="12">
              <div class="main-placeholder right martb5">
                <vs-checkbox id="addMoreChild" class="w-full" name="addMoreChild" v-model="children.addMoreChild"
                  @click="togleField({section:'children' ,subsection:'',field:'addMoreChild'})">Add Child</vs-checkbox>
              </div>
            </vs-col>

          </div>




        </form>
      </div>
    </div>

    <vs-collapse accordion>
    </vs-collapse>

    <vs-popup class="holamundo success-popups" title="Your registration is complete."
      :active.sync="SuccessQuestionnaire">
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire submitted successfully!</h2>
      <p>It will be reviewed by the petitioner and appropriate actions will be taken soon.</p>
    </vs-popup>

    <vs-popup class="holamundo success-popups" title="Template configuration complete."
      :active.sync="showFinalsubmitPopup">
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire template submission!</h2>
      <p>Are you sure to continue?</p>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="showFinalsubmitPopup=false">Cancel</vs-button>
        <vs-button color="success" class="save ml-3" type="filled" @click="saveMe(true)">Yes</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
  import { FormWizard, TabContent } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import Datepicker from "vuejs-datepicker-inv";
  import moment from 'moment'
  import PhoneMaskInput from "vue-phone-mask-input";
  import JQuery from 'jquery';
  import { TheMask } from 'vue-the-mask';
  import FileUpload from "vue-upload-component/src";
  import _ from "lodash";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Vue from 'vue'

  export default {
    props:{
      templateId:{
        default:''
      }
    },
    // balu data
    data() {
      return {
        currentroute:this.$route.params.itemId,
        selectedcountryOfBirth:[],
        selectedcitizenship:[],
        salaryOfferedType: [],
        resumeDocs: [],
        educationDocs: [],
        experienceDocs: [],
        insNoticeDocs: [],
        passportVisaI94Docs: [],
        formI20Docs: [],
        socialSecurityCardAndProfLicenseDocs: [],
        childDocumentArray: [{
          childvisa: [],
          childpassport: [],
          childformI94: [],
          childbirthCertificate: [],
        }],
        childvisa: [],
        childpassport: [],
        childformI94: [],
        childbirthCertificate: [],
        visaDocuments: [],
        formI94: [],
        formI797Docs: [],
        marriageCertificateDocs: [],
        birthCertificate: [],
        // openDate: new Date().setFullYear(new Date().getFullYear() - 18),
        startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
        startBeneficiaryDateEntered: new Date().setFullYear(new Date().getFullYear() - 7),
        SuccessQuestionnaire: false,
        formerrors: {
          msg: ""
        },
        petition: [],
        beneficiaryInfo: {
          firstName: '',
          lastName:'',
          email: '',
          gender: null,
          maritalStatus: null,
          education: {
            highestDegree: "",
            majorFieldOfStudy: ""
          },
          address: {},
          
          ben_currentlyInUS:false,
          ben_haveOwnershipInterest: false,
          ben_ownershipInterestDesc: false,
          ben_consulateInfo: false,
          ben_alienNumber: false,
          ben_lastArrivalDate: false,
          ben_placeOfLastEntryInUS: false,
          ben_educations: false,
          ben_nonImmPetitionsInfo: false,
          ben_anyImmPetitionFiled: false,
          ben_immPetitionInfo: false,
          ben_prevEmploymentInfo:false,
          ben_addressOutsideUS: false,


          hasI140ImmPetitionFiled: true,
          SSN: ''
        },
        clientInfo: {
          address: {}
        },
        dependentsInfo: {
          spouse: {
            email:'',
            phoneNumber:'',
            phoneCountryCode:"+1",
            h4Required: true,
            h4EADRequired: null,
            lastArrivalDate:null,
            statusExpiryDate:null,
            physicalAddress: {

            },
            documents: {
              passport: [],
              visa: [],
              formI94: [],
              formI797: [],
              marriageCertificate: [],
              birthCertificate: [],
              other:[]
            }
          },
          childrens: [{
            documents: {
              passport: [],
              visa: [],
              formI94: [],
              birthCertificate: [],
              other:[]
            }
          }]
        },
        documents: {
          resume: [],
          education: [],
          expLetters: [],
          INSNotices: [],
          passportVisaI94: [],
          formI20: [],
          socialSecurityCardAndProfLicense: [],
          I140ApprovalNotice:[],
          payStubs:[],
          offerLetter:[],
          clientLetter:[],
          vendorLetter:[],
          msa:[],
          po:[], 
          other:[],
           },
        bncountryModel: [],
        checkCountry: false,
        countries: [],
        states: [],
        clientstates: [],
        stateModel: [],
        locations: [],
        locationModel: [],
        marital_statuses: [],
        education_types: [],
        visastatuses: [],
        clientcountryModel: [],
        clientstateModel: [],
        clientlocationModel: [],
        clientlocations: [],
        spousecountryModel: [],
        suposestates:[],
        souuselocations:[],
        spouseaddresscountryModel:null,
        spouseaddressstateModel:null,
        spouseaddresslocationModel:null,

        chiildcountryModel: [],
        clientInfo_salaryFrequency_Details:[],
        priorstay: {
          enteredDate: null,
          departedDate: null,
          visaStatus: null
        },
        priorPeriodOfStayInUS: [],
        childrensarray: [],
        children: [{
          "h4Required": true,
          "firstName": null,
          "middleName": null,
          "lastName": null,
          "dateOfBirth": null,
          "countryOfBirth": null,
          "selectedcountryOfBirth":null,
          "selectedcitizenship":null,
          "passportNumber": null,
          "passportExpiryDate": null,
          "I94": null,
          "visaIssuedDate": null,
          "currentStatus": null,
          "statusExpiryDate": null,
          "documents": {
          }
        }],
        countrySelected: '',
        countryOfCitizenshipSelected: '',
        latestPetition: '',

        //Cinfiguration 
        beneficiary: {
          first_name: false,
          middle_name: false,
          last_name:false,
          email: false,
          gender: false,
          dob:false,
         dateOfBirth: false,
          marital_status:false,
          cell_phone_number:false,
          home_phone_number:false,
          ben_hasOtherNames:false,

          countryOfBirth:false,
          provinceOfBirth:false,
          locationOfBirth:false,
          countryOfCitizenship:false,
          I94:false,
          I94ExpiryDate:false,

          I94StatusName:false,
          passportIssuedCountry:false,

          immPetitionPriorityDate: false, // list your Priority Date obtained from your previous immigrant petition

          applyI485AdjOrConsuProcess: false, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },

          adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },

          consularProcessing:false,// Consular Processing { type: Boolean, default: false },

          areYouUnderRemoveOfIndOrUscis: false, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },






           "passportNumber":false,
          "passportExpiryDate":false,
          passportIssuedDate:false,
          curNonImmigrantVisaStatus:false,
          curVisaExpiryDate:false,
          sevisNumber:false,
          eadNumber:false,
         //new fields
          ben_currentlyInUS:false,
          ben_haveOwnershipInterest: false,
          ben_ownershipInterestDesc: false,
          ben_consulateInfo: false,
          ben_alienNumber: false,
          ben_lastArrivalDate: false,
          ben_placeOfLastEntryInUS: false,
          ben_educations: false,
          ben_nonImmPetitionsInfo: false,
          ben_anyImmPetitionFiled: false,
          ben_immPetitionInfo: false,
          ben_prevEmploymentInfo:false,
          ben_addressOutsideUS: false,
           //new fields end





          education: {
            highest_degree: false,
            major_field_of_study: false
          },
          mailingAddress:false,
          address: {
            iam_notfrom_us:false,
            iam_from_us:false,
            beneficiary_address_line1:false,
            beneficiary_address_line2:false,
            beneficiary_address_country:false,
            beneficiary_address_state:false,
            beneficiary_address_city:false,
            beneficiary_address_zipcode:false,
          },
          hasI140ImmPetitionFiled: false,
          SSN: false,
          consulateNotifyAddress:false,
          docs_i140_approval_notice:false,
         
          priorPeriodOfStayInUS:false,
          documents:{
            docs_passport:false,
             docs_resume:false,
            docs_education:false,
            docs_exp_letters:false,
            docs_ins_notices:false,
            docs_passport_visa_i94:false,
            docs_form_i20_ead:false,
            docs_ssc_licence:false,
            docs_paystubs:false,
            docs_offer_letters:false,
            docs_employmentAggrementLatters:false, //new Item
            docs_client_letters:false,
            docs_vendor_letters:false,
            docs_msa:false,
            docs_po:false,
            docs_ead:false,
             docs_I797NoticeofApprovalforI140:false,
           

            "docs_h1b_reg_selection_notice":false,
            "docs_employment_agreement":false,
            "docs_prime_vendor":false,
            "docs_form_i94":false,
            "docs_prior_form_i797":false,

              slgResume:false,

              slgCollegeDegreesCert: false,

              slgTransScripts: false,

              slgExpLetters: false,

              slgPassportAndVisa: false,

              slgI94: false,

              slgPrevNonimmApprovalNotices: false,

              slgI140OrPermNoties: false,

              slgPrevLaborApplications: false,

              slgAckOfPrevLaborApplications: false,

              slgPaystubs: false,

              slgI20: false,

              slgEad: false,

            docs_other:false

          },
         
        },
         spouse:{ 

           //new fields
            spo_relationship: false,
            spo_currentlyInUS: false,
            spo_hasOtherNames: false,
            spo_otherNames:false,
            spo_passportIssuedDate: false,
            spo_alienNumber: false,
            spo_addressOutsideUS: false,
            spo_priorPeriodOfStayInUS: false,
            //new fields end

            spouse_h4_required:false,
            spouse_h4_ead_required:false,
            spouse_first_name:false,
            spouse_middle_name:false,
            spouse_last_name:false,
            spouse_email:false,
            spouse_phone_number:false,
            spouse_dob:false,
            spouse_cob:false,
            spouse_provinceOfBirth:false,
            spouse_locationOfBirth:false,
            spouse_passport_number:false,
            spouse_passport_expiry_date:false,
            spouse_i94:false,
            spo_I94ExpiryDate:false,
            spouse_country_of_citizenship:false,
            spouse_current_status:false,
            spouse_status_expiry_date:false,
            spouse_ssn:false,
            spouse_date_of_last_arrival:false,
            addMoreChild:false,
            address: {
           
            spouse_address_line1:false,
            spouse_address_line2:false,
            spouse_address_country:false,
            spouse_address_state:false,
            spouse_address_city:false,
            spouse_address_zipcode:false,
          },
          documents:{
            "spouse_docs_passport": false, 
            "spouse_docs_visa": false,
            "spouse_docs_formi94": false,
            "spouse_docs_form_i797": false,
            "spouse_docs_mrg_certificate": false,
            "spouse_docs_form_i20":false,
            "spouse_docs_pay_stubs":false,
            "spouse_docs_other": false,
            "spouse_docs_noticeOfApprovalOfH1Status":false,
            "spouse_docs_approvalNoticeOfPrevH4":false


          }

          },
         children:{
           //new fields
            chi_relationship: false,
            chi_currentlyInUS: false,
            chi_hasOtherNames:false,
            chi_otherNames:false,
            chi_alienNumber: false,
            chi_lastArrivalDate: false,
            chi_placeOfLastEntryInUS: false,
            chi_physicalAddress: false,
            chi_addressOutsideUS: false,
            chi_passportIssuedDate: false,
            chi_priorPeriodOfStayInUS: false,
            chi_provinceOfBirth:false,
            chi_locationOfBirth:false,
            //new fields end


            child_h4_required:false,
            child_first_name: false,
            child_middle_name: false,
            child_last_name:false,
            child_email: false,
            gender: false,
            dob:false,
            child_dob:false,
            child_cob:false,
            child_gender:false,
            child_passport_number:false,
            child_passport_expiry_date:false,
            child_i94:false,
            child_i94_expiry_date:false,
            child_country_of_citizenship:false,
            child_current_status:false,
            child_marital_status:false,
            child_status_expiry_date:false,
            documents:{
               "child_docs_passport": false, 
               "child_docs_visa": false,
                "child_docs_form_i94": false,
                "child_docs_form_i797": false,
                "child_docs_approvalNoticeOfPrevH4":false,
               "child_docs_birth_certificate": false,
               "child_docs_approval_notice": false,
                "child_docs_other":false

            },
            addMoreChild:false,

          },  
        questionnaireConfigData:{ name:'' , questionnaireId:'',  fields:[], sections:[]  },
        configId:null,
        configDetails:null,
        showFinalsubmitPopup:false,
      };
    },
    methods: {
      validateIp4ExpiryDate( cat){
        //validateIp4ExpiryDate('spouse' ,'spouse_i94' ,'spo_I94ExpiryDate')
        setTimeout(() =>{
          if(cat=='spouse'){
           if(!this.spouse['spouse_i94']){
            this.spouse['spo_I94ExpiryDate'] =false;
            this.questionnaireConfigData['fields'] = _.remove(this.questionnaireConfigData['fields'], (n)=> {
              
              return n.trim() !='spo_I94ExpiryDate';
             });
           }

          }
        //child_i94:false, child_i94_expiry_date:false,
          
          if(cat=='children'){
           if(!this.children['child_i94']){
            this.children['child_i94_expiry_date'] =false;
            this.questionnaireConfigData['fields'] = _.remove(this.questionnaireConfigData['fields'], (n)=> {
              
              return n.trim() !='child_i94_expiry_date';
             });
           }

          }
           // beneficiary I94 ,I94ExpiryDate
          if(cat=='beneficiary'){
           if(!this.beneficiary['I94']){
            this.beneficiary['I94ExpiryDate'] =false;
            this.questionnaireConfigData['fields'] = _.remove(this.questionnaireConfigData['fields'], (n)=> {
              
              return n.trim() !='I94ExpiryDate';
             });
           }

          }
        
         

        },10)
        
        
      },
      togleField({section='' ,subsection='',field=''}){
       
        //questionnaireConfigData:{  fields:[], sections:[]  }
        
        if(field !='' && section !='' ){
          let action = false;
          if(section !='' &&  subsection !=''){
           
            action = this[section][subsection][field];
             section = section+"_"+subsection;
          }else{
             action = this[section][field];;
          }
          
          if(action){
            action = false;
          }else{
             action = true;
          }
         
         //alert(field);
        
          if(this.questionnaireConfigData['sections'].indexOf(section)<=-1){

            //this.questionnaireConfigData['sections'].push(section.trim())
          }
          if(action){
            //add field
            if(this.questionnaireConfigData['fields'].indexOf(field.trim())<=-1){

              this.questionnaireConfigData['fields'].push(field.trim())
            }
          }else{
            //remove field
            this.questionnaireConfigData['fields'] = _.remove(this.questionnaireConfigData['fields'], (n)=> {
              
            return n.trim() !=field.trim();
        });


          }
          
        }

      },
     
      
      
      beforedocumentsTabSwitch() {
             window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
          return true
        // return true;
      },
     beforeTabSwitch() {
       
        
         return this.validateStep("beneficiaryInfoform" ,this.beneficiary);
        // return true;
      },
      beforeClient() {
        //alert('clientInfoform')
        return this.validateStep("clientInfoform");
        // return true;
      },
      beforeDependents() {

       
                
         // alert('dependentsInfoform')
        //  return true;
         return this.validateStep("dependentsInfoform");
      },
      async validateStep(step ,data) {

          let itemsCount =0;
          let selectedItemsCount =0;
          _.forEach(data ,(item ,index)=>{
            if(typeof item == "boolean"){
                itemsCount =itemsCount+1;
                if(item ==true){
                  selectedItemsCount =selectedItemsCount+1;
                }
                  
            }else{

              _.forEach(item ,(subitem ,subindex)=>{
                if(typeof subitem == "boolean"){
                        itemsCount =itemsCount+1;
                        if(subitem ==true){
                          selectedItemsCount =selectedItemsCount+1;
                        }
                }
                

              });
              
            }


          });

        const result = await this.$validator.validateAll(step).then(result => {
          return result;
        });
        if (result) {
          this.$validator.reset();
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        } else {
          const $ = JQuery;
          const firstField = Object.keys(this.errors.collect())[0];
          const ele = $('[name=' + firstField + ']').parents('.vx-col');
          $('html, body').animate({ scrollTop: ele.offset().top }, 2000);
        }
        return result;
      },
      finalSubmit(){
        this.showFinalsubmitPopup =true;
      },
     
      saveMe(isFinalSUbmit=false) {
        let questionnaireConfigData = _.cloneDeep(this.questionnaireConfigData);
        if(_.has(questionnaireConfigData , 'fields')){
          questionnaireConfigData['fields'] = _.sortedUniq(questionnaireConfigData.fields)
        }
        if(_.has(questionnaireConfigData , 'sections')){
          questionnaireConfigData['sections'] = _.sortedUniq(questionnaireConfigData.sections)
        }
        if(isFinalSUbmit){
          questionnaireConfigData = Object.assign(questionnaireConfigData ,{"configCompleted":true});
          questionnaireConfigData['configCompleted'] = true;
        }

        questionnaireConfigData = Object.assign(questionnaireConfigData,{ "tenantId":null});
        if(_.has(this.configDetails  ,"tenantId")){

            questionnaireConfigData = Object.assign(questionnaireConfigData,{ "tenantId":this.configDetails['tenantId']});

        }
        

        this.$store.dispatch("commonAction" ,{"data":questionnaireConfigData , "path":"/questionnaire/update"})
        .then((res)=>{
          this.showToster({message:res.message ,isError:false});
          this.showFinalsubmitPopup =false;
          this.getConfigDetails();
          
        

            setTimeout(()=>{
               if(this.templateId){
           
                  this.$emit("gotoList");

              }else{
                  this.$router.push("/questionnaire-templates-list")
              }
          },10)

         
         

        })
        .catch((err)=>{

           this.showToster({message:err ,isError:true});
        })
       },
      
     
      checkTemplateField(checkKey=''){
        let return_value = true;
        if( checkKey !='' && _.has(this.petition ,"templateFileds") ){
          return_value = _.findIndex( this.petition.templateFileds ,(el)=>{ return el==checkKey })>-1?true:false;
        }
        return return_value;
      },
      mapData(){
        let dataVeriables = ['beneficiary' ,'spouse' ,'children'];
        _.forEach(dataVeriables ,(ver)=>{
            _.forEach(this[ver] ,(item ,fld )=>{
                if(typeof item == "boolean"){
                  
                  if(this.configDetails['fields'].indexOf(fld) >-1){

                    
                    
                    try{
                      this[ver][fld] =true;
                      this.questionnaireConfigData.fields.push(fld);
                    }catch(err){
                      
                    }
                  }

                    
                      
                }else{

                  _.forEach(item ,( subitem ,fldVal)=>{
                      if(typeof subitem == "boolean"){
                              if(this.configDetails['fields'].indexOf(fldVal) >-1){
                                  try{
                                    this[ver][fld][fldVal] =true;
                                     this.questionnaireConfigData.fields.push(fldVal);
                                  }catch(err){
                                    
                                  }
                                    
                              }
                              
                      }
                  });
                  
                }
            });
        });

      },
      getConfigDetails(){
        let postData = {questionnaireId:this.configId};
        this.$store.dispatch("commonAction" ,{  "data":postData ,"path":"/questionnaire/details" })
        .then((res)=>{
          //alert(JSON.stringify(res.name));
          this.configDetails = res;
          this.questionnaireConfigData['name'] = res.name
           this.questionnaireConfigData['questionnaireId'] = this.configId;
          //questionnaireConfigData:{ name:'' , questionnaireId:'',  fields:[], sections:[]  },
          this.mapData();
         

        })

      },
      
   },
   beforeDestroy(){
     this.SuccessQuestionnaire = false;
              document.removeEventListener('click', this.reloadthePage);
   },
    mounted() {
       this.configId = this.$route.params.id;
      if(this.templateId){
       this.configId = this.templateId;
     }
       this.getConfigDetails();
       
      
    JQuery('#btnSidebarToggler').click()
     
      setTimeout(function(){
           window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })

      },1500)
          
      //this.$route.params.itemId
    },
    components: {
      FormWizard,
      TabContent,
      Datepicker,
      PhoneMaskInput,
      TheMask,
      FileUpload,
      VuePerfectScrollbar
    },
    watch: {
      'beneficiaryInfo.iAmFromUS': function(value) {
        if(value === 'true') {
          
          this.checkCountry = false;
          this.setDefaultcountry();
    
        } else {
          this.checkCountry = true;
                this.stateModel = null;
          this.locationModel = null;
        }
      },
      'maritalStatusOpen': function(value) {
        
        
      } 
    },
  };
</script>